import { render } from "./Titel.vue?vue&type=template&id=47a28150"
import script from "./Titel.vue?vue&type=script&lang=js"
export * from "./Titel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__